import { Col, Image, Input, Row, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import localStorageKey from "../../../../../enumerations/localStorageKey";
import {
  useGetProductCountryList,
  useGetProductItemDetail,
} from "../../../../../hooks/HomeProduct/homeproduct.hooks";

import { useNavigate } from "react-router-dom";
import { pushGtag } from "../../../../../plugins/gtagFunction";
import SearchIcon from "../icons/SearchIcon";
import styles from "./style.module.scss";
import "./style.scss";
const ProductArea = ({
  setSelectedCountry,
  selectedCountry,
}: {
  setSelectedCountry: (val: number | string) => void;
  selectedCountry: number | string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");
  const { data, isPending } = useGetProductCountryList(
    { search_str: debouncedInputValue },
    {}
  );

  const { data: countryCode } = useGetProductItemDetail(
    { product_id: selectedCountry },
    {
      enabled: !!selectedCountry,
    }
  );

  const localLang = window.localStorage
    .getItem(localStorageKey.DEFAULT_LANG)
    ?.replace(/-/gm, "_");

  const handleInputChange = (event: any) => {
    setInputValue(event.target.value);
  };

  const getSeoTagMap = useCallback((key: string) => {
    const envSeoTag = process.env.REACT_APP_SEO_PRODUCT_TAG_MAPPING;

    if (!envSeoTag) {
      return key;
    }

    const seoTagMap = JSON.parse(envSeoTag);

    return seoTagMap[key] || key;
  }, []);

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 800);

    return () => clearTimeout(delayInputTimeoutId);
  }, [inputValue]);

  useEffect(() => {
    if (countryCode) {
      const seoTag = getSeoTagMap(countryCode?.country_code);

      navigate(`/product?id=${selectedCountry}&code=${seoTag}`, {
        state: { id: selectedCountry },
      });
    }
  }, [countryCode]);

  return (
    <div className={styles.productArea} id="homeProductArea">
      <div className={styles.contentContainer}>
        <div className={styles.title}>{t("home.2esim.product.part.title")}</div>
        <div className={styles.subTitle}>
          {t("home.2esim.product.part.sub.title")}
        </div>
        <Input
          value={inputValue}
          onChange={handleInputChange}
          // style={{ maxWidth: "379px" }}
          prefix={<SearchIcon />}
          suffix={
            <div className={styles.searchSuffix}>
              <SearchIcon color="var(--grey)" />
            </div>
          }
          className={`${styles.inputBox} product-search-input`}
          placeholder={t("home.2esim.product.part.input.placeholder")}
        />
        <div className={styles.countryListContainer}>
          <Spin spinning={isPending}>
            {data?.length > 0 ? (
              <Row
                gutter={[
                  { xs: 0, sm: 0, md: 16 },
                  { xs: 16, sm: 16, md: 16 },
                ]}
              >
                {data?.map((item: any, index: any) => (
                  <Col
                    key={"country" + index}
                    className="gutter-row"
                    lg={{ span: 8 }}
                    md={{ span: 8 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                  >
                    <div
                      className={styles.countryItem}
                      onClick={() => {
                        console.debug("item", item);
                        setSelectedCountry(item.id);
                        pushGtag({
                          event: "home_product_click",
                          ...item,
                        });
                      }}
                    >
                      <Image
                        src={item?.img}
                        preview={false}
                        className={styles.countryIcon}
                        alt={`country-${item.country_name_en_US}`}
                        height={40}
                        width={40}
                        fallback="data:image/png;base64,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"
                      />
                      <div className={styles.countryName}>
                        {item[`country_name_${localLang}`] ?? "-"}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            ) : isPending ? (
              ""
            ) : (
              <div
                className={styles.nodataHint}
                dangerouslySetInnerHTML={{ __html: t("home.search.noresult") }}
              />
            )}
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default ProductArea;
